import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-localize-redux';
import { IconSizes, IconVariants } from '../../components/foundations/Icon';
import { Button, Icon, SmallDialog } from '../../components/widgets';
import { route } from '../../utils/routerUtils';
import { translationPrefix as translationRootPrefix } from '../utils';
import css from './ConfigurationRequiredDialog.css';

const translationPrefix = `${translationRootPrefix}.CONFIGURATION_REQUIRED_DIALOG`;

const ConfigurationRequiredDialog = ({ open, pages, onClose, translate }) => {
    const renderPageButton = ({ link, translationKey }) => (
        <Button
            type="primary"
            text={`${translationPrefix}.GO_TO_PAGE`}
            textReplace={{ pageDisplayName: translate(translationKey) }}
            key={translationKey}
            onClick={() => {
                route(link);
                onClose();
            }}
        />
    );

    return (
        <SmallDialog open={open} onClose={onClose} onEscapePress={onClose} classes={{ paperScrollBody: css.dialog }}>
            <div className={css.content}>
                <div className={css.header}>
                    <Icon name="alert-triangle" size={IconSizes.LARGE} variant={IconVariants.WARNING} />
                    <Translate id={`${translationPrefix}.TITLE`} />
                </div>
                <Translate id={`${translationPrefix}.DESCRIPTION`} />
                <div className={css.buttonsContainer}>
                    <Button type="flat" text={`${translationPrefix}.CANCEL`} onClick={onClose} />
                    {pages.map(renderPageButton)}
                </div>
            </div>
        </SmallDialog>
    );
};

ConfigurationRequiredDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    pages: PropTypes.arrayOf(
        PropTypes.shape({
            link: PropTypes.string.isRequired,
            translationKey: PropTypes.string.isRequired,
        })
    ).isRequired,
    onClose: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default ConfigurationRequiredDialog;
